import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { UserModel } from 'src/app/models/user.model';
import { UserService } from 'src/app/services/user.service';
import { OfferService } from './../../services/offer.service';
import { OfferDetailModel, ProductModel } from 'src/app/models/wardrobe.model';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CounterOfferModalComponent } from '../counter-offer-modal/counter-offer-modal.component';
import { STATUS_ACCEPTED, STATUS_REJECTED, STATUS_PROCESSING } from 'src/app/constants/general.constant';
import { DeliveryPickupModalComponent } from '../delivery-pickup-modal/delivery-pickup-modal.component';

@Component({
  selector: 'shc-offer-item',
  templateUrl: './offer-item.component.html',
  styleUrls: ['./offer-item.component.scss'],
})
export class OfferItemComponent implements OnInit {
  userDetail: UserModel;
  STATUS_ACCEPTED: string;
  STATUS_REJECTED: string;
  STATUS_PROCESSING: string;
  @Input() offerItem: OfferDetailModel;
  @Output() notifyCounterOffer = new EventEmitter();

  constructor(
    private router:Router,
    private modalCtrl: ModalController,
    private offerService: OfferService,
    private errorService: ErrorHandlerService,
    private userService: UserService,
    protected translate: TranslateService,
  ) { }

  ngOnInit() {
    this.STATUS_ACCEPTED = STATUS_ACCEPTED;
    this.STATUS_REJECTED = STATUS_REJECTED;
    this.STATUS_PROCESSING = STATUS_PROCESSING;
    this.userService.get().subscribe(res => {
      this.userDetail = res;
    });
    console.log("this.STATUS_ACCEPTED", this.STATUS_ACCEPTED)
  }

  showOfferType(offerType: string) {
    if(offerType === 'PRICE_DISCOUNT') {
      return this.translate.instant('CounterOffer.Title');
    } else {
      return this.translate.instant('SwapItem.Title');
    }
  }

  acceptOffer(): void {
    this.offerService.updateOffer(this.offerItem.id, STATUS_ACCEPTED).subscribe(res => {
      this.offerItem = res;
      // this.showPickupModal();
    }, error => {
      this.errorService.handle(error);
    });
  }

  declineOffer(): void {
    this.offerService.updateOffer(this.offerItem.id, STATUS_REJECTED).subscribe(res => {
      this.offerItem = res;
    }, error => {
      this.errorService.handle(error);
    });
  }

  async counterOffer() {
    const modal = await this.modalCtrl.create({
      component: CounterOfferModalComponent,
      componentProps: {
        product: this.offerItem?.product,
        senderId: this.offerItem?.sent_by?.id
      },
      cssClass: 'counterOfferModal',
      canDismiss: true,
      backdropDismiss: true,
      id: 'counterOffer',
      mode: 'md'
    });
    modal.onDidDismiss().then((data) => {
      if (data && data.data) {
        this.notifyCounterOffer.emit(data.data);
      }
      this.modalCtrl.dismiss();
    });
    return await modal.present();
  }

  gotoOfferedProduct(offeredProduct: ProductModel) {
    this.router.navigate(['wardrobe', 'detail', offeredProduct?.id]);
  }

  // async showPickupModal() {
  //   const modal = await this.modalCtrl.create({
  //     component: DeliveryPickupModalComponent,
  //     canDismiss: false,         // Prevent closing with swipe or ESC
  //     backdropDismiss: false,    // Prevent closing by clicking outside
  //     // componentProps: {
  //     //   productId: productId,
  //     //   chatId: this.chatId
  //     // }
  //   });
  //   await modal.present();

  //   // const { data, role } = await modal.onWillDismiss();
  //   // if (role === 'submit' && data) {
  //   //   this.sendCloudService.sendOrderToCloud('delivery', data);
  //   // }
  // }
  
}
